enum ContactListFeatures {
  CONTACT_LIST = 'contact-list',
}

export default ContactListFeatures;
